<form>
    <cp-notification-delivery [pressedSubmit]='pressedSubmit'
        [notificationFormGroup]="notificationFormGroup"></cp-notification-delivery>
    <cp-signup-footer-controls (nextClicked)="submitForm()" focusOnError="true"></cp-signup-footer-controls>
</form>